import { CommunicationAttachment } from '../../AttachmentArbiter/Attachment';
import { createRenderingTracker, trackingKey } from '../createRenderingTracker';

/**
 * Why a tracker for communications?
 * Today the report intentionally renders nothing for communications
 * (visit notes etc.) per physician feedback — they make good citations but
 * not member-facing widgets. The tracker exists so that if/when inline
 * communication widgets come back, they get the same dedup behavior as
 * every other attachment type without needing a one-off implementation.
 * Identity is the FHIR `ResourceType/id`.
 */
export type CommunicationTrackerInput = {
  attachment: CommunicationAttachment;
};

const handle = createRenderingTracker<CommunicationTrackerInput>(
  ({ attachment }) => trackingKey(attachment.identifier),
);

export const CommunicationTrackingProvider = handle.Provider;
export const useCommunicationTracker = handle.useTracker;
